import apiClient from './api';

export interface Repository {
  id: string;
  url: string;
  name: string;
  owner: string;
  description: string | null;
  added_by: string;
  created_at: string;
  updated_at: string;
}

export async function getRepositories(): Promise<Repository[]> {
  const response = await apiClient.get<Repository[]>('/api/repositories');
  return response.data;
}

export async function addRepository(url: string, description?: string): Promise<Repository> {
  const response = await apiClient.post<Repository>('/api/repositories', { url, description });
  return response.data;
}

export async function deleteRepository(id: string): Promise<void> {
  await apiClient.delete(`/api/repositories/${id}`);
}
